import JourneyPlaceFormulaCreatePage from '../../components/pages/journey-places/formula/journey-place-formula-create'
import JourneyPlaceFormulaUpdatePage from '../../components/pages/journey-places/formula/journey-place-formula-update'
import { Paths } from '../../lib/constants/path'
import { RoleEnum } from '../../lib/types/enums/users/role.enum'
import { Route } from '../../lib/types/routes'
import JourneyPlacesFormulaWishListPage from './formulas/journey-places-formula-wish-list'
import JourneyPlaceCreatePage from './journey-place-create'
import JourneyPlaceUpdatePage from './journey-place-update'
import JourneyPlaceListPage from './journey-places-list'
import JourneyPlaceCreateOptionPage from './options/journey-place-option-create'
import JourneyPlaceOptionUpdatePage from './options/journey-place-option-update'
import JourneyPlaceOptionsPage from './options/journey-place-options'

const journeyPlaceRoutes: Route[] = [
  {
    path: Paths.JOURNEY_PLACE_LIST_PAGE,
    element: <JourneyPlaceListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.JOURNEY_PLACE_CREATE_PAGE,
    element: <JourneyPlaceCreatePage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.JOURNEY_PLACE_UPDATE_PAGE,
    element: <JourneyPlaceUpdatePage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.FORMULA_WISH_LIST,
    element: <JourneyPlacesFormulaWishListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.FORMULA_WISH_LIST_CREATE_PAGE,
    element: <JourneyPlaceFormulaCreatePage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.FORMULA_WISH_LIST_UPDATE_PAGE,
    element: <JourneyPlaceFormulaUpdatePage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.JOURNEY_PLACE_OPTIONS_LIST_PAGE,
    element: <JourneyPlaceOptionsPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.JOURNEY_PLACE_OPTION_CREATE_PAGE,
    element: <JourneyPlaceCreateOptionPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.JOURNEY_PLACE_OPTION_UPDATE_PAGE,
    element: <JourneyPlaceOptionUpdatePage />,
    roles: [RoleEnum.ADMIN]
  }
]

export default journeyPlaceRoutes
